import * as React from 'react';

const ShopCartIcon = (props) => (
  <svg
    width='33'
    height='33'
    viewBox='0 0 33 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path='url(#clip0_716_34)'>
      <path
        d='M25.009 24.5215C22.8971 24.5215 21.1558 26.2258 21.1558 28.3747C21.1558 30.4866 22.8601 32.2279 25.009 32.2279C27.1209 32.2279 28.8622 30.5236 28.8622 28.3747C28.8252 26.2628 27.1209 24.5215 25.009 24.5215Z'
        fill='currentColor'
      />
      <path
        d='M31.7891 6.14426C31.715 6.14426 31.6039 6.10721 31.4927 6.10721H8.15106L7.78056 3.62484C7.55826 1.99463 6.15035 0.771973 4.48308 0.771973H1.48201C0.666905 0.771973 0 1.43888 0 2.25398C0 3.06909 0.666905 3.73599 1.48201 3.73599H4.48308C4.66833 3.73599 4.81654 3.8842 4.85359 4.06945L7.1507 19.7047C7.44711 21.6683 9.15142 23.1503 11.1521 23.1503H26.565C28.4917 23.1503 30.1589 21.7795 30.5665 19.8899L32.9747 7.84858C33.1229 7.07052 32.6042 6.29246 31.7891 6.14426Z'
        fill='currentColor'
      />
      <path
        d='M15.5611 28.1895C15.487 26.1517 13.7827 24.5215 11.7449 24.5215C9.59602 24.6326 7.9658 26.411 8.0399 28.5229C8.114 30.5607 9.78127 32.1909 11.819 32.1909H11.8931C14.005 32.0797 15.6723 30.3013 15.5611 28.1895Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_716_34'>
        <rect width='33' height='33' fill='currentColor' />
      </clipPath>
    </defs>
  </svg>
);

export default ShopCartIcon;
